import { ChartDonutIcon } from './ChartDonutIcon';

/**
 * author: Google
 * id C7BED6AB-8D91-42EC-A22F-D4B922B0EB14
 * name chart-donut
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-donut.svg
 * tags
 * - Math 
 */
export const ReportDonutIcon = ChartDonutIcon;
export default ReportDonutIcon